/* Centered toolbar element: formatted puzzle number + a real-time
   countdown to 00:00 UTC, when the next puzzle drops worldwide. The
   countdown ticks once per second; the timer self-corrects to wall-clock
   time on every tick (so a backgrounded tab catches up on resume). */

import { useEffect, useState } from "preact/hooks";
import { formatHms, msUntilNextUtcMidnight } from "../game/countdown";
import { puzzle, puzzleNumber } from "../game/state";

export function PuzzleStatus() {
  const [hms, setHms] = useState(() => formatHms(msUntilNextUtcMidnight()));

  useEffect(() => {
    const tick = () => setHms(formatHms(msUntilNextUtcMidnight()));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);

  // When there's no puzzle (pre-launch, API outage, gap in pipeline),
  // show only the countdown — the placeholder '000' id was just noise
  // because the player has nothing to play.
  const hasPuzzle = puzzle.value != null;
  return (
    <div class="puzzle-status" aria-live="off">
      {hasPuzzle && (
        <>
          <span class="puzzle-status__id">{puzzleNumber.value}</span>
          <span class="puzzle-status__sep" aria-hidden="true"> • </span>
        </>
      )}
      <span class="puzzle-status__countdown">
        Next<span class="puzzle-status__countdown-word"> Puzzle</span> {hms}
      </span>
    </div>
  );
}
